import mergedInvoiceHandler from "@/services/MergedInvoice";

export default {
    async loadMergedInvoices({commit, dispatch}, payload) {
        const {data} = await mergedInvoiceHandler.all(payload);

        commit('SET_MERGED_INVOICES', data);
    },
    async getByMergedInvoiceId({commit, dispatch}, payload) {
        return mergedInvoiceHandler.get(payload);
    },
    async updateMergedInvoicePayment({commit, dispatch}, payload) {
        return mergedInvoiceHandler.updateManualPayment(payload);
    },
    async storeMergedInvoice({commit, dispatch}, payload) {
        return mergedInvoiceHandler.store(payload);
    },
    async updateMergedInvoice({commit, dispatch}, payload) {
        return mergedInvoiceHandler.update(payload);
    },
    async destroyMergedInvoice({commit, dispatch}, payload) {
        return mergedInvoiceHandler.destroy(payload);
    },
    async removeMergedInvoice({commit, dispatch}, payload) {
        return mergedInvoiceHandler.remove(payload);
    },
    async mergedMailHandler({commit, dispatch}, payload) {
        return mergedInvoiceHandler.mergedMailHandler(payload);
    },
    async updateMergedMailHandler({commit, dispatch}, payload) {
        return mergedInvoiceHandler.updateMergedMailHandler(payload);
    },
}
